<template lang="pug">
.page-container
  .page-block
    .down-load-btn(@click="goDownload(true)") 立即打开/下载
    .down-load-word
      span 如未安装请根据提示
      span.bule-word(@click="goDownload(false)") 下载App
    .down-load-word 如下载较慢，请前往手机自带应用市场下载
  .shadow(v-if="showShadow()")
    .shaow-block
      img(src="https://m.hellobike.com/resource/gallery/61/OH4lcakU_Group%206.png?x-oss-process=image/quality,q_80")
</template>
<script>
import Device from '@skillnull/device-js';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { env } from '@hb/hbridge';
import { getDeviceInfo } from '../../api/device';
import { ParamsUtil } from '../../utils/params';
import { getSystemCode } from '../../utils/systemCode';

export default {
  data() {
    return {
      deviceType: {},
      timer: null,
    };
  },
  async created() {
    await Device.Info().then(async (data) => {
      this.deviceType = data;
    });
    this.getData();
  },
  async mounted() {
    if (!this.showShadow()) {
      window.location.href = 'hellobike://hellobike.com';
      this.timer = setTimeout(() => {
        this.goDownload();
      }, 3000);
    }
    UBT.pageView({
      pageId: 'platform_download_invoke',
      categoryId: 'platform',
      businessInfo: {},
    });
  },
  beforeDestroy() {
    UBT.pageViewOut({
      pageId: 'platform_download_invoke',
      categoryId: 'platform',
      businessInfo: {},
    });
    this.timer = null;
  },
  methods: {
    async getData() {
      const {
        app, scenes, source, placetype, accountid, bizline, usertype,
      } = ParamsUtil.getParams(window.location.href);
      try {
        await getDeviceInfo({
          app,
          scenes,
          source,
          placetype,
          accountid,
          bizline,
          usertype,
          userAgent: this.deviceType.userAgent,
          deepLink: `${window.location.href}`,
          channelInfo: ParamsUtil.getParams(window.location.href),
          systemCode: getSystemCode(),
        });
      // eslint-disable-next-line no-empty
      } catch {

      }
    },
    showShadow() {
      if (env.isWeixin || env.isAliMP || env.isAliMPMonitor || env.isAlipayBrowser) {
        return true;
      }
      return false;
    },
    goDownload(val) {
      if (val) {
        UBT.clickButton({
          pageId: 'platform_download_invoke',
          buttonName: 'platform_download_invokebutton',
          categoryId: 'platform',
          businessInfo: {},
        });
      } else {
        UBT.clickButton({
          pageId: 'platform_download_invoke',
          buttonName: 'platform_download_invokebutton_secondary',
          categoryId: 'platform',
          businessInfo: {},
        });
      }
      window.location.href = 'https://at.umtrack.com/onelink/e41jGr';
    },
  },
};
</script>
<style lang="less">
.page-container {
  background-image: url(https://m.hellobike.com/resource/gallery/61/-hAmQ_c6ai.png?x-oss-process=image/quality,q_80);
  background-size: 100% 100%;
  height: 100%;
  width: 100%;
  padding-top: 5.37rem;

  .page-block {
    .down-load-btn {
      margin: 0 auto 0.1rem auto;
      background: #08f;
      border-radius: 0.05rem;
      width: 3.35rem;
      height: 0.48rem;
      text-align: center;
      line-height: 0.48rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-size: 0.18rem;
      font-weight: 500;
      color: #fff;
    }

    .down-load-word {
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-size: 0.12rem;
      font-weight: 500;
      text-align: center;
      color: #999;

      .bule-word {
        color: #08f;
        text-decoration: underline;
      }
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.92);
    z-index: 100;
    opacity: 0.7;

    .shaow-block {
      top: 0.12rem;
      right: 0.26rem;
    }
  }
}
</style>
